export const ocrQualityMessages = {
  'zh-CN': {
    manualEnhancement: '手动区域 · 通用增强',
    preprocessRejected: '图像预处理未成功，尚未送入 OCR。请框选完整数值并留少量边距。',
    worldsLevelPreprocessRejected: '未能确认完整的底栏等级，尚未送入 OCR。请框选完整等级数字并保留少量边距；若包含 LV.，请保持标签完整。',
    lowConfidence: '上次读到“{text}”，置信度 {confidence}，未达到 {minimumConfidence}。',
    failed: '上次等级读取未采用：{reason}。',
    retrying: '正在重试，请保持游戏画面可见。',
    minimumConfidence: '等级确认门槛',
    attempt: '等级尝试 {index}',
  },
  en: {
    manualEnhancement: 'Manual region · general enhancement',
    preprocessRejected: 'Image preparation failed and OCR has not run. Select the complete value with a small margin.',
    worldsLevelPreprocessRejected: 'The complete HUD level could not be confirmed and was not sent to OCR. Select all level digits with a small margin. If LV. is included, keep the entire label visible.',
    lowConfidence: 'Last read “{text}” at {confidence} confidence; at least {minimumConfidence} is required.',
    failed: 'The last level reading was rejected: {reason}.',
    retrying: 'Retrying. Keep the game visible.',
    minimumConfidence: 'Level confidence threshold',
    attempt: 'Level attempt {index}',
  },
}
